export { useDealHooks } from "./use-deals-hooks/entity-hooks";
export { useCreateDeal, useDeleteDeal, useUpdateDeal } from "./use-deals-hooks/mutations";
